module.exports = __webpack_public_path__ + "static/media/Set_account_name.d0877968.svg";